window.app = window.app || (function(){
    return {
        data: {}
    }
})();
